import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export default function Itemcards(prop) {
    const { data } = prop;
    const S3_URL = "https://extremewheelsdevelopment.s3-accelerate.amazonaws.com/";
    const navigate = useNavigate();

    const [loaderShow, setLoaderShow] = useState(false);
    const handleSubmit = (event) => {
        setLoaderShow(true)
        const item_id = data.sku;
        setTimeout(() => {
            navigate(`/premium_wheels_product_details/${item_id}`);

            window.location.reload();
            setLoaderShow(false)
        }, 1000); // Delay of 2000 milliseconds (2 seconds)


    };
    let first_image_path = "";
    let image = data.image_url1.trim();
    let logo = data.logo;

    if (image) {
        first_image_path = image;
    } else if (logo) {
        first_image_path = logo;
    }
    const onSubmit = (item) => {
        // navigate('/brands/brands-products', { state: item });       


    };

    let product_name_ = `${data.brand_desc} ${data.style} ${data.fancy_finish_desc} ${data.size_desc}  ${data.wheel_offset}MM  ${data.bolt_pattern_metric}`

    return (
        <div className="col-lg-2 col-6 customeChanges">

            <div className="Drivetrain-cart wheelsPage">
                {/* {
                    data.msrp_usd && data.msrp_usd >= 100 ? (
                        <div className="ribbon"><span>Free Shipping</span></div>
                    ) : (
                        ""
                    )
                } */}
                <div className="engle-imge-upper" onClick={handleSubmit}>
                    {
                        !loaderShow ?
                            <button className="hover-btn " >  View Details </button>
                            :
                            <button className="hover-btn loading " > Loading  </button>
                    }


                    {
                        data && first_image_path ?
                            <img className="" src={first_image_path} alt="img" height="100%" width="100%" />
                            :
                            <img className="w-100 h-auto" src="/images/coming_soon.jpg" alt="img" height="100%" width="100%" />

                    }
                </div>

                <div className="cart-body">
                    <span onClick={handleSubmit} style={{ cursor: 'pointer' }}>
                        <h4 className='similar_pro_cat_name'>{ }</h4>
                        <span className="m-0 description text-dark" >
                            {data.product_desc}
                        </span>
                        {/* <span className="m-0 description text-dark" >{data.vendor_id == 5 || data.vendor_id == 6 ? data.product_name : data.vendor_id == 7 && data.product_name == "ESR - -  0MM 5X105" ? data.product_desc : product_name_}</span> */}
                    </span>

                    <div className="price-cart">
                        <div className="price mt-2">
                            <strong>{data.sku}</strong>
                        </div>
                        <div className="price" title='Stock'>
                            {
                                data.quantity == 0 ?
                                    <span><i className="fa fa-industry text-danger" aria-hidden="true"> </i> {data.quantity}</span>
                                    :
                                    <span><i className="fa fa-industry text-success" aria-hidden="true"></i> {data.quantity}</span>
                            }

                        </div>
                    </div>



                    <div className="price-cart mt-3">

                        <div className="price">
                            {/* {
                                data?.msrp_usd ?
                                    <h5 className="m-0">${parseFloat(data.msrp_usd).toFixed(2)}</h5>
                                    :
                                    <h5 className="m-0">N.A</h5>
                            } */}
                            {
                                data && (Number(data.map_usd) > 0 || Number(data.msrp_usd) > 0) && (
                                    <h4 className="m-0">
                                        ${Number(data.map_usd) > 0 ? parseFloat(data.map_usd).toFixed(2) : parseFloat(data.msrp_usd).toFixed(2)}
                                    </h4>
                                )
                            }
                        </div>

                        <div className="cart-btn">
                            <a
                                // href={`/wheels?brandname=${data.brand_desc}&brandid=${data.brand_id}`}
                                // style={{ cursor: 'pointer' }}
                            >
                                {
                                    data?.logo ?
                                        // <img src={S3_URL + data.logo} alt="img" height="100%" width="100%" />
                                        <img src={data.logo} alt="img" height="100%" width="100%" />
                                        :
                                        <img src="/images/no-image-found.png" alt="img" height="100%" width="100%" />

                                }
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>




    )
}
